<template>
  <div id="gasPopup" @click.stop="closePopup">
    <div class="contentBox" @click.stop>
      <div class="daySelectBox">
        <el-image
          class="daySelectBg"
          fit="fill"
          :src="require('@/assets/selDayBg.png')"
        ></el-image>
        <div class="dayBox">
          <div
            class="dayItemBox"
            v-for="(dayItem, index) in days"
            :key="index"
            :class="{ isSelectedCls: dayItem.isSelected }"
            @click.stop="selectedDayItem(dayItem)"
          >
            <el-image
              class="dayItemBg"
              v-show="dayItem.isSelected"
              fit="fill"
              :src="require('@/assets/selDayBorder.png')"
            ></el-image>
            <span class="dayText">{{ dayItem.text }}</span>
          </div>
        </div>
      </div>
      <div class="chartBox">
        <el-image
          class="chartBorderImg"
          fit="fill"
          :src="chartData.bgImg"
        ></el-image>
        <div class="maxAndMinTemp" v-if="selectedDay.type == 1">
          <span class="leftContrast">后{{selectedDay.value}}天是前{{selectedDay.value}}天的</span>
          <span class="rightContrast">{{gasContrast}}</span>
          <span>%</span>
        </div>
        <div class="maxAndMinTemp" v-if="selectedDay.type == 2 && !isNowDate">
          <span class="maxTempCls">最高温度: {{ this.maxOutDoorTemp }}℃</span>
          <span>最低温度: {{ this.minOutDoorTemp }}℃</span>
        </div>
        <smart-gas-temp-chart
          class="chart"
          v-if="isNowDate && selectedDay.type == 2"
          :chartData="chartData"
          :equipmentData="equipmentData"
        ></smart-gas-temp-chart>
        <gas-temp-bar-chart
          class="chart"
          v-if="!isNowDate || selectedDay.type == 1"
          :xData="chartBarXaxis"
          :gasData="chartBarData"
        ></gas-temp-bar-chart>
      </div>
    </div>
  </div>
</template>
<script>
import SmartGasTempChart from "@/components/subComponents/smartGasTempChart.vue";
import GasTempBarChart from "@/components/subComponents/smartGasTempBarChart.vue";
import requestObjc from "@/utils/requestObjc";
export default {
  name: "gasPopup",
  components: {
    SmartGasTempChart,
    GasTempBarChart,
  },
  data() {
    return {
      selectedDay: null,
      chartBarXaxis: [],
      chartBarData: [],
      gasContrast: 0,
      days: [
        {
          text: "5天",
          value: 5,
          isSelected: false,
          type: 1,
        },
        {
          text: "10天",
          value: 10,
          isSelected: false,
          type: 1,
        },
        {
          text: "15天",
          value: 15,
          isSelected: false,
          type: 1,
        },
        {
          text: "20天",
          value: 20,
          isSelected: false,
          type: 1,
        },
        {
          text: "25天",
          value: 25,
          isSelected: false,
          type: 1,
        },
        {
          text: "30天",
          value: 30,
          isSelected: false,
          type: 1,
        },
      ],
    };
  },
  props: {
    chartData: null,
    equipmentData: null,
    isNowDate: Boolean,
    selectedDateStr: "",
    maxOutDoorTemp: 0,
    minOutDoorTemp: 0,
  },
  created() {
    var selDate = {
      text: this.selectedDateStr.replace("/-/g", "."),
      isSelected: true,
      type: 2,
    };
    this.days.push(selDate);
    this.selectedDay = selDate;
    this.$set(this, "chartBarXaxis", [this.selectedDay.text]);
    this.$set(this, "chartBarData", [this.chartData.gasQuantity]);
  },
  mounted() {},
  methods: {
    //选择日期
    selectedDayItem(dayItemData) {
      if (dayItemData.text == this.selectedDay.text) return;
      this.$set(this, "selectedDay", dayItemData);
      if (dayItemData.type == 2) {
        this.chartBarXaxis = [dayItemData.text];
      } else {
        var axis1 = "前" + dayItemData.value + "天";
        var axis2 = "后" + dayItemData.value + "天";
        this.$set(this, "chartBarXaxis", [axis1, axis2]);
      }
      var newDays = [];
      this.days.forEach((dayItem) => {
        if (dayItem.isSelected) {
          dayItem.isSelected = false;
        }
        if (dayItem.text === dayItemData.text) {
          dayItem.isSelected = true;
        }
        newDays.push(dayItem);
      });
      this.$set(this, "days", newDays);
      if (dayItemData.type == 2) {
        this.chartBarData = [this.chartData.gasQuantity];
        return;
      }
      this.requestData();
    },
    closePopup() {
      this.$emit("closeGasTempPopup");
    },
    requestData() {
      this.$set(this, "chartBarData", []);
      var params = {
        date: this.selectedDateStr,
        days: this.selectedDay.value,
      };
      requestObjc
        .requestHeatingGasWithDay(params, this.chartData.id)
        .then((res) => {
          var dataArr = [res.data.data1, res.data.data2];
          var contrast = Math.floor((res.data.data2 / res.data.data1) * 100);
          this.$set(this, "gasContrast", contrast);
          this.$set(this, "chartBarData", [...dataArr]);
        })
        .catch((err) => {
          console.log("获取采暖前后天气量失败" + err);
        });
    },
  },
};
</script>
<style scoped>
#gasPopup {
  background-color: rgba(2, 5, 9, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.contentBox {
  width: 50%;
  height: 50%;
}
.daySelectBox {
  width: 80%;
  height: 10%;
  position: relative;
  margin-left: 8%;
}
.chartBox {
  width: 100%;
  height: 88%;
  margin-top: 5%;
  position: relative;
}
.dayBox {
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 8%;
  right: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  color: #3eabd6;
}
.dayItemBox {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.dayItemBox:hover {
  cursor: pointer;
}
.dayItemBg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.daySelectBg {
  width: 100%;
  height: 100%;
}
.isSelectedCls {
  color: white;
  font-size: 26px;
}
.chartBorderImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.chartBorderImg {
  z-index: 1;
}
.chart {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 10px;
  z-index: 4;
}
.maxAndMinTemp {
  font-size: 12px;
  position: absolute;
  z-index: 3;
  height: 10%;
  top: 5%;
  width: 100%;
  color: #4bceff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FD7B25;
}
.maxTempCls {
  margin-right: 10px;
}
.leftContrast {
  font-size: 14px;
}
.rightContrast {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartSystems/gasTempPopup.vue